<div class="td col-time layout-column layout-align-center-start">
  <span class="br-body-1">{{ log() | bringozFullDate: 'createdAt' }} {{ log() | bringozTime: 'createdAt' }}</span>
</div>

<div class="td col-event layout-column layout-align-center-start">
  @for (event of events(); track $index) {
    <span class="br-body-1 margin-bottom-10">{{ eventKey() | translate: event }}</span>
  }
</div>

<div class="td col-user layout-column layout-align-center-start">
  <span class="br-body-1 font-weight-600">{{ log().createdBy?.name }}</span>
  @if (log().createdBy?.holderType) {
    <span class="br-body-1 font-weight-400">{{ 'TIMELINE_LOG_HOLDER_TYPES.' + log().createdBy.holderType | translate }}</span>
  }
</div>

<div class="td col-source text-ellipsis layout-column layout-align-center-start">
  <span class="br-body-1">{{ (log().source ? 'TIMELINE_LOG_SOURCES.' + log().source : '---') | translate }}</span>
</div>
